const PDF_PATH = require.context('../../static/pdf', true);

import {PdfFile} from '../types/page';
import {LessThan, NumRange} from '../types/helpers';
import {SupportedLangs, SupportedRegions} from '../types/lang';
import {LiquidPowder, LiquidsPowders, PdfKeys} from '../types/data';


type LiquidsPowdersData = Record<string, {
  type1: LiquidPowder,
  type2: LiquidPowder,
}>;

export const getLiquidsPowders = (data: LiquidsPowdersData, selectedRegion: SupportedRegions) => {
  const references: LiquidsPowders = {
    liquids: [],
    powders: [],
  };

  for (const type of Object.keys(data) as Array<keyof LiquidsPowdersData[1]>) {
    Object.values(data[type]).map((value) => {
      for (const region of value.available_countries) {
        if (region === selectedRegion) {
          references[type === 'type1' ? 'liquids' : 'powders'].push(value);
        }
      }
    });
  }

  return references;
}

export const extractData = (data: Record<string, any>, category: number) => {
  const extractedData: Record<string, any> = {};
  const dataToExtract = data[`category${category}`];

  for (const key of Object.keys(dataToExtract)) {
    if (key.startsWith('type')) {
      extractedData[key] = dataToExtract[key].products;
    }
  }

  return extractedData;
};

export const convertVersionToLanguage = (value: string): SupportedLangs => {
  if (value === 'French version' || value.endsWith(SupportedLangs.FR)) return SupportedLangs.FR;
  if (value === 'Chinese version' || value.endsWith(SupportedLangs.CN)) return SupportedLangs.CN;
  if (value === 'Spanish version' || value.endsWith(SupportedLangs.ES)) return SupportedLangs.ES;
  return SupportedLangs.EN;
};

export const getAllPdf = (parameter: 'all' | 'certificates') => {
  type Doc = Record<SupportedLangs, PdfFile[]>;

  const documentsOrdered: Record<PdfKeys, Doc> = {
    src: {en: [], fr: [], cn: [], es: []},
    srf: {en: [], fr: [], cn: [], es: []},
    sri: {en: [], fr: [], cn: [], es: []},
    srus: {en: [], fr: [], cn: [], es: []},
  };

  const updateDocuments = (type: string, folder: string, version: string, name: string) => {
    const lang = convertVersionToLanguage(version);
    const publicURL = ['/pdf', type, folder, version, name].join('/');
    documentsOrdered[type.toLowerCase() as Lowercase<PdfKeys>][lang].push({name, version, publicURL});
  };

  for (const key of PDF_PATH.keys()) {
    const [_dot, type, folder, languageVersion, file] = key.split('/');
    if (parameter === 'all') updateDocuments(type, folder, languageVersion, file);
    if (parameter === 'certificates' && folder === 'Certificates & Statements') updateDocuments(type, folder, languageVersion, file);
  };

  return documentsOrdered;
};

export const getUrlQueryParams = (): Record<string, string | undefined> => {
  if (typeof window === 'undefined') return {};

  const search = window.location.search;
  const params = new URLSearchParams(search);

  const result: Record<string, string> = {};
  params.forEach((value, key) => result[key] = value);

  return result;
};

export function getCategoryFromUrl<T extends LessThan<10>>(nbOfCategories: T, defaultCategory: NumRange<1, T>): NumRange<1, T> {
  // Array of categories from 1 to nbOfCategories
  const categories = Array.from(Array(nbOfCategories).keys()).map((i) => i + 1);

  const queryParams = getUrlQueryParams();
  if (!queryParams.category) return defaultCategory;

  const category = parseInt(queryParams.category.replace('category', ''));
  if (isNaN(category) || !categories.includes(category)) return defaultCategory;
  return category as NumRange<1, T>;
};

export function initCategories<T extends LessThan<10>>(_: T, defaultCategory: NumRange<1, T>): NumRange<1, T> {
  return defaultCategory;
};
